import { React, useEffect, useRef, useState } from "react";
import horizontalSplit from "./utils/horizontalSplit";
import splitArray from "./utils/splitArray";
import "../../../../../../Components/Radio/Radio.css";

// import {BsFillCircleFill, BsDiamondFill, BsFillSquareFill,} from "react-icons/bs";
// import { TbMinusVertical } from "react-icons/tb";
// import { ImCross } from "react-icons/im";
// const getParaIcon = (shape) => {
//   switch (shape) {
//     case "circle":
//       return <BsFillCircleFill />;
//     case "square":
//       return <BsFillSquareFill />;
//     case "diamond":
//       return <BsDiamondFill />;
//     case "lineVertical":
//       return <TbMinusVertical />;
//     case "cross":
//       return <ImCross />;
//     default:
//       return <BsFillCircleFill />;
//   }
// };

const getAlignment = (text_alignment, columns) => {
  switch (text_alignment) {
    case "left":
      if (columns === 1) {
        return [" text-start "];
      } else if (columns === 2) {
        return [" text-start ", " text-start "];
      } else if (columns === 3)
        return [" text-start ", " text-start ", " text-start "];
      else if (columns === 4) {
        return [" text-start ", " text-start ", " text-start ", " text-start "];
      } else {
        return [" text-start ", " text-start ", " text-start ", " text-start ", " text-start ",];
      }

    case "justify":
      if (columns === 1) {
        return [" text-start "];
      } else if (columns === 2) {
        return [" text-start ", " text-end "];
      } else if (columns === 3)
        return [" text-start ", " text-center ", " text-end "];
      else if (columns === 4) {
        return [" text-start ", " text-start ", " text-end ", " text-end "];
      } else {
        return [" text-start ", " text-start ", " text-center ", " text-end ", " text-end ",];
      }

    case "right":
      if (columns === 1) {
        return [" text-end "];
      } else if (columns === 2) {
        return [" text-end ", " text-end "];
      } else if (columns === 3)
        return [" text-end ", " text-end ", " text-end "];
      else if (columns === 4) {
        return [" text-end ", " text-end ", " text-end ", " text-end "];
      } else {
        return [" text-end ", " text-end ", " text-end ", " text-end ", " text-end ",];
      }

    case "center":
      if (columns === 1) {
        return [" text-center "];
      } else if (columns === 2) {
        return [" text-center ", " text-center "];
      } else if (columns === 3)
        return [" text-center ", " text-center ", " text-center "];
      else if (columns === 4) {
        return [" text-center ", " text-center ", " text-center ", " text-center ",];
      } else {
        return [" text-center ", " text-center ", " text-center ", " text-center ", " text-center ",];
      }
    default:
      if (columns === 1) {
        return [" text-end "];
      } else if (columns === 2) {
        return [" text-end ", " text-start "];
      } else if (columns === 3)
        return [" text-end ", " text-center ", " text-start "];
      else if (columns === 4) {
        return [" text-end ", " text-end ", " text-start ", " text-start "];
      } else {
        return [" text-end ", " text-end ", " text-center ", " text-start ", " text-start ",];
      }
  }
};

const getPadding = (textAlignment, noOfCols, colIdx, gutter) => {
  gutter = gutter;
  let pl = 0;
  let pr = 0;
  if (textAlignment === "gutter") {
    if (noOfCols == 2) {
      if (colIdx == 0) pr = gutter;
      if (colIdx == 1) pl = gutter;
    }
    if (noOfCols == 4) {
      if (colIdx == 1) pr = gutter;
      if (colIdx == 2) pl = gutter;
    }
  }
  return {
    paddingLeft: `${pl}px`,
    paddingRight: `${pr}px`,
  };
};

export default function NameOnly2({items, options, fontStyle, settings, idx,}) {
  const bulletRefs = useRef([]);

  const newItems = [];
  items.map((it) => {
    if (it.name) newItems.push(it);
  });
  items = newItems;
  // console.log('items = ', items);
  const [...itemsCopy] = items;

  const sortedItems =
  options.column_order === null ? itemsCopy : options.column_order === "ascending" ? itemsCopy.sort((a, b) => a?.name?.localeCompare(b?.name)) : itemsCopy.sort((a, b) => b?.name?.localeCompare(a?.name));

  const arraySplitData = options.column_flow === "vertical" ? splitArray(sortedItems, options)?.ans : horizontalSplit(sortedItems, options)?.ans;

  const textAlignment = getAlignment(options?.text_alignment, options?.columns);

  const bulletAlignJSON = { left: "start", right: "end", center: "center" };

  const [bulletClass, setBulletClass] = useState("");
  
  const [hideBullets, setHideBullets] = useState([]);

  useEffect(() => {
    if (!options?.bullets) return;

    const rows = {};
    bulletRefs.current.forEach((el, i) => {
      if (!el) return;
      const top = el.offsetTop;
      if (!rows[top]) rows[top] = [];
      rows[top].push(i);
    });

    const hide = new Set();

    // ✅ Remove bullet ONLY from last name in each line
    Object.values(rows).forEach((row) => {
      if (row.length > 0) {
        hide.add(row[row.length - 1]);
      }
    });

    setHideBullets([...hide]);
  }, [items, options, fontStyle]);

  useEffect(() => {
    const bulletClasses = {
      circle: "circle",
      square: "li-square",
      diamond: "diamond",
      lineVertical: "lineVertical",
      cross: "cross",
    };

    if (options.bullets !== null && options.bullets && bulletClasses[options.bullets]) {
      setBulletClass(bulletClasses[options.bullets]);
    }
  }, [options.bullets]);

  return options?.bullets ? (
    <div className="flex flex-col justify-center w-full overlaytext">
      <div id={"list" + idx} className={"FontSIzeScale  m-auto flex flex-wrap justify-" + bulletAlignJSON[options.text_alignment]}
        style={{
          ...fontStyle?.nameOnlyStyle,
          width: options.column_width + "%",
          lineHeight: fontStyle?.nameOnlyStyle?.lineHeight + 0.15,
          fontKerning: "none",
          fontFeatureSettings: '"kern" 0',
          textRendering: "geometricPrecision",
          WebkitFontSmoothing: "antialiased",
        }}
      >
        {items.map((item, i) => (
          <div key={i} ref={(el) => (bulletRefs.current[i] = el)} className="grid grid-flow-col items-center justify-center ">
            <p className="FontSIzeScale m-0 p-0"
              style={{
                ...fontStyle?.nameOnlyStyle,
                fontKerning: "none",
                fontFeatureSettings: '"kern" 0',
                textRendering: "geometricPrecision",
                WebkitFontSmoothing: "antialiased",
              }}
            >
              {item.name}
            </p>

            <span className={`FontSIzeScale bullet ${bulletClass} ${hideBullets.includes(i) ? "rmNewClassbullets" : "" }`} />
          </div>
        ))}
      </div>
    </div>
  ) : (
    <div className={`flex flex-row flex-wrap overlaytext ${options?.columns === 1 ? "justify-center" : ""} ${options?.text_alignment === "gutter" ? "justify-center" : ""} `}
      style={{width: `${options.column_width * options.columns}%`, margin: "0 auto", wordBreak: "break-word",}}
    >
      {arraySplitData.map((items, index) => (
        <div key={index} className={`flex flex-col flex-1 break-words float-left`}
          style={{
            ...getPadding(
              options.text_alignment,
              arraySplitData.length,
              index,
              settings.gutter,
            ),
          }}
        >
          {items.map((item, idx) => (
            <p key={idx} className={` FontSIzeScale ${textAlignment[index]}`}
              style={{
                ...fontStyle?.nameOnlyStyle,
                lineHeight: fontStyle?.nameOnlyStyle.lineHeight,
                fontKerning: "none",
                fontFeatureSettings: '"kern" 0',
                textRendering: "geometricPrecision",
                WebkitFontSmoothing: "antialiased",
              }}
            >
              {item.name}
            </p>
          ))}
        </div>
      ))}
    </div>
  );
}
